<template>
  <div v-if="store.isLoadingComplete">
    <ColorEditor v-if="controlName == 'ColorEditor'" />
    <ArtEditor v-if="controlName == 'ArtEditor'" />
    <FontEditor v-if="controlName == 'FontEditor'" />
    <TextEditor v-if="controlName == 'TextEditor'" />
    <MonogramEditor v-if="controlName == 'MonogramEditor'" />
    <ProductEditor v-if="controlName == 'ProductEditor'" />
    <MaterialEditor v-if="controlName == 'MaterialEditor'" />
    <ProductDesign v-if="controlName == 'ProductDesign'"  />
    <AllProducts v-if="controlName == 'AllProducts'" />
    <EmbroidMechine v-if="controlName == 'EmbroidMechine'" />
    <ManagerEditor v-if="controlName == 'ManagerEditor'" />
    <AllOrders v-if="controlName == 'AllOrders'" />
    <TryRotate v-if="controlName == 'TryRotate'" />
    <DesignScreen v-if="controlName == 'DesignScreen'" />
  <!-- {{ uStore.userDesigns }} -->
    <ColorFilters></ColorFilters>
  </div>
</template>                                          

<script>
import FontEditor from "./components/FontEditor.vue";
import ColorEditor from "./components/ColorEditor.vue";
import ArtEditor from "./components/ArtEditor.vue";
import TextEditor from "./components/TextEditor.vue";
import MonogramEditor from "./components/MonogramEditor.vue";
import ProductEditor from "./components/ProductEditor.vue";
import MaterialEditor from "./components/MaterialEditor.vue";
import ColorFilters from "./components/ColorFilters.vue";
import ProductDesign from "./components/ProductDesign.vue";
import AllProducts from "./components/AllProducts.vue";
import EmbroidMechine from "./components/EmbroidMechine.vue";
import ManagerEditor from "./components/ManagerEditor.vue";
import AllOrders from "./components/AllOrders.vue";
import TryRotate from "./components/TryRotate.vue";
import DesignScreen from "./components/DesignScreen.vue";
import { designerStore } from "@/stores/designerStore";
import { userStore } from "@/stores/userStore";


export default {
  name: "App",
  components: {
    FontEditor,
    ColorEditor,
    ArtEditor,
    TextEditor,
    MonogramEditor,
    ProductEditor,
    ColorFilters,
    MaterialEditor,
    ProductDesign,
    AllProducts,
    EmbroidMechine,
    ManagerEditor,
    AllOrders,
    TryRotate,
    DesignScreen
  },
  setup() {
    const store = designerStore();
    const uStore = userStore();

    return {
      store,
      uStore,
    };
  },
  inject: ["cname"], //, "pid"],
  data() {
    return {
      controlName: this.cname,
      productId: this.pid,
      imageId: 0,
    };
  },
  async mounted() {
    
    // if(this.cname == 'AllProducts') {
    //   setInterval(this.store.checkUserDesignsStore(), 60000);
    // } else {
    //   setInterval(this.store.checkDBStorage, 60000);
    // }
    // await this.store.syncShopifyProduct();//מפעיל את סנכרון הסטור עם החנות
    
    
    const isUser=this.cname=="DesignScreen";
    if (!isUser)
      await this.store.loadAppAdmin(); // מסנכרן למשתמש את הדאטה לסטור
    else
      await this.store.loadAppUser();
    
 
 
    // this.store.isConflict=false;
    // this.store.conflictArray =  this.store.keysArray.filter(key => {
    //       const localData = JSON.parse(localStorage.getItem(key));     
    //       console.log( localData.date);
    //     console.log(this.store.allStoresHashs[key]?.lastMod); 
    //       return localData && localData.date  && localData.date<this.store.allStoresHashs[key]?.lastMod;
    //   }).map(key=>{
    //     return {key:key,
    //       preference:""}
    //   }); 
    //   if(this.store.conflictArray.length>0)
    //   this.store.isConflict=true; 
    // console.log(this.store.isConflict)


    // if (this.controlName == "ProductDesign") {
    //   console.log("p2-id = ", this.pid);
    //   if (this.pid !== undefined) {
    //     this.productId = this.pid;
    //     this.imageId = Object.values(
    //       this.store.allProducts[this.productId].images
    //     )[0].imageID;

    //   } else {
    //     console.log("p-id = ", this.pid);
    //     this.productId = this.pid;
    //     this.imageId = Object.values(
    //       this.store.allProducts[this.productId].images
    //     )[0].imageID;
    //   }
    // }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
  width: calc(100vw - 30px);
  /* font-family: Roboto, Helvetica, Arial, sans-serif; */
}
.openDesignTag:hover {
  color: #6f974c !important;
  text-decoration-color: #6f974c !important;
  text-decoration-line: underline !important;
}
div:empty {
    display: unset;
}
</style>    
       
 
      
               